<script>
import Component, { mixins } from 'vue-class-component';
import ChipGroup from './ChipGroup.vue';

@Component
export default class LegendGroupChips extends mixins(ChipGroup) {
  parseGroupInfo() {
    const parsedGroup = {};
    this.groupInfo.forEach((dt) => {
      parsedGroup[dt.code_name] = { label: dt.translation, clickDisabled: true };
    });
    return parsedGroup;
  }
}
</script>
